

























































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import store from "@/store";
//  @components
//  @types
import { Company } from "@/types/company";
import { CellData } from "@/types/VDataTable";
//  @modules
import { getModule } from "vuex-module-decorators";
import CompaniesModule from "@/store/clients/Companies.module";

const Companies = getModule(CompaniesModule, store);

@Component({
  components: {},
})
export default class DataCell extends Vue {
  @Prop({ type: Object }) data!: CellData;
  @Prop({ type: Array, default: () => [], required: true }) vessels!: any[];

  // @Data
  isCompanyMenuOpen = false;
  companySearch: string = "";
  internalSelected: Company | null = null;

  //  @Getters
  get isActionsDataCell(): boolean {
    return this.data.type === "actions";
  }

  get isActionSelectDataCell(): boolean {
    return this.data.type === "action-select" && this.data.value === "";
  }

  get companies(): Company[] {
    return Companies.companies;
  }

  get selectedCompany(): Company | null {
    if (!this.internalSelected) return null;
    return this.internalSelected;
  }

  get filteredCompanies(): Company[] {
    if (!this.companySearch) return this.companies;
    const q = this.companySearch.toLowerCase();
    return this.companies.filter(c => (c.name || "").toLowerCase().includes(q));
  }

  //  @Methods
  assignCompany(): void {
    if (!this.selectedCompany) return;
    this.$emit("AssignCompanyEvent", {
      vesselId: this.data.vesselId,
      companyId: this.selectedCompany.id,
    });
  }
  // map action name to icon and emitted event name (handler)
  getActionConfig(action: string): { icon: string; eventName: string } {
    switch ((action || "").toLowerCase()) {
      case "edit":
        return { icon: "$Edit", eventName: "EditEvent" };
      case "delete":
        return { icon: "$Delete", eventName: "DeleteEvent" };
      case "archive":
        return { icon: "$Archive", eventName: "ArchiveEvent" };
      case "activate":
        return { icon: "$Play", eventName: "ActivateEvent" };
      case "deactivate":
        return { icon: "$Pause", eventName: "DeactivateEvent" };
      default:
        return { icon: "$Edit", eventName: "EditEvent" };
    }
  }

  handleAction(action: string, payload: any = undefined): void {
    const cfg = this.getActionConfig(action);
    payload = this.data.vesselId ? this.data.vesselId : payload;
    this.$emit(cfg.eventName, payload);
  }

  selectCompany(company: Company): void {
    this.internalSelected = company;
    this.isCompanyMenuOpen = false;
    this.companySearch = "";
    this.$nextTick(() => {
      // Validate imo in company after selection
      const companyField = (this.$refs as any).companyField;

      if (companyField) {
        companyField.validate();
      }
    });
  }

  companyImoRule(): string | boolean {
    // only validate if both company and IMO are set
    if (!this.selectedCompany || !this.data.imo) return true;

    const selectedCompanyName = this.selectedCompany.name;

    // Check if any vessel in the selected company has this IMO
    // (excluding the current vessel being edited)
    const duplicate = this.vessels.find(v => v.imoNumber === this.data.imo && v.companyName === selectedCompanyName && v.id !== this.data.vesselId);
    return duplicate ? "IMO number exists in this company" : true;
  }
}
